import { render, staticRenderFns } from "./xiangmulayuntongji.vue?vue&type=template&id=603142f6&scoped=true&"
import script from "./xiangmulayuntongji.vue?vue&type=script&lang=js&"
export * from "./xiangmulayuntongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603142f6",
  null
  
)

export default component.exports